import { useEffect, useState } from "react";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";

const ModalDescuentoCotizacion = ({
    isOpen,
    item,
    onClose,
    onApply,
}) => {
    const precioBaseConISV = parseFloat(item?.price) || 0;
    const [montoDescuento, setMontoDescuento] = useState(0);
    const [precioIngresado, setPrecioIngresado] = useState(precioBaseConISV);

    useEffect(() => {
        setPrecioIngresado(precioBaseConISV);
        setMontoDescuento(0);
    }, [item]);

    const handleAplicar = () => {
        const nuevoPrecioConImpuesto = parseFloat(precioIngresado) || 0;
        const descuentoIngresado = parseFloat(montoDescuento) || 0;
        let precioFinalConISV = nuevoPrecioConImpuesto - descuentoIngresado;
        if (precioFinalConISV < 0) precioFinalConISV = 0;
        const impuesto = item.impuesto || item.isv || '0%';
        const porcentajeISV = impuesto === "15%" ? 0.15 : impuesto === "18%" ? 0.18 : 0;

        let precioFinalSinISV = 0;
        let montoISV = 0;

        if (porcentajeISV > 0) {
            precioFinalSinISV = precioFinalConISV / (1 + porcentajeISV);
            montoISV = precioFinalConISV - precioFinalSinISV;
        } else {
            precioFinalSinISV = precioFinalConISV;
            montoISV = 0;
        }

        const montoDescuentoAplicado = descuentoIngresado;

        const precioActualNumerico = parseFloat(item?.price) || 0;

        const precioOriginalAlAbrirModal = item?.precioAjustadoOriginal
            ? parseFloat(item.precioAjustadoOriginal)
            : precioActualNumerico;

        onApply({
            ...item,
            precioAjustadoOriginal: parseFloat(precioOriginalAlAbrirModal.toFixed(2)),
            price: parseFloat(precioFinalConISV.toFixed(2)),
            precioSinImpuesto: parseFloat(precioFinalSinISV.toFixed(2)),
            isvAplicado: parseFloat(montoISV.toFixed(2)),
            descuentoEspecialMonto: parseFloat(montoDescuentoAplicado.toFixed(2)),
        });
        onClose();
    };

    const precioStateNum = parseFloat(precioIngresado) || 0;
    const descuentoStateNum = parseFloat(montoDescuento) || 0;

    let precioDespuesDeAjuste = precioStateNum - descuentoStateNum;
    if (precioDespuesDeAjuste < 0) precioDespuesDeAjuste = 0;

    if (!item) return null;

    return (
        <ModalBootstrap
            titulo={`Descuento/Precio para: ${item?.nombre || ""}`}
            modalIsOpen={isOpen}
            setModalIsOpen={onClose}
            mostrarBoton={false}
            pie={
                <button className="btn btn-primary" onClick={handleAplicar}>
                    Aplicar Cambios
                </button>
            }
        >

            <div className="mb-3">
                <label className="form-label fw-bold">Nuevo precio (L)</label>
                <input
                    type="number"
                    className="form-control"
                    min="0"
                    value={precioStateNum}
                    onChange={(e) => {
                        setPrecioIngresado(parseFloat(e.target.value) || 0);
                    }}
                />
            </div>
            {/*
            <div className="mb-3">
                <label className="form-label fw-bold">Descuento (L)</label>
                <input
                    type="number"
                    className="form-control"
                    min="0"
                    value={descuentoStateNum}
                    onChange={(e) => {
                        setMontoDescuento(parseFloat(e.target.value) || 0);
                    }}
                />
            </div>*/}
        </ModalBootstrap>
    );
};

export default ModalDescuentoCotizacion;